import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Col, Container, Row, Alert, Label } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";

// import images
import logodark from "../../../assets/images/logo-dark.png";
import logolight from "../../../assets/images/logo-light.png";
import CarouselPage from "../../AuthenticationInner/CarouselPage";
import SuperAdminLogin from "components/form/super-admin/login-form/SuperAdminLogin";
import rexo_logo from '../../../assets/images/custom/logo_decima.png'


class Login2 extends Component {

  render() {

    return (
      <>

        <Container fluid className="p-0">
          <Row className="g-0">
            <CarouselPage />

            <Col xl={3}>
            <div className="auth-full-page-content p-md-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5">
                      <Link to="dashboard" className="d-block auth-logo">
                        {/* <img src={logodark} alt="" height="18" className="auth-logo-dark" />
                        <img src={logolight} alt="" height="18" className="auth-logo-light" /> */}
                         
                      </Link>
                    </div>
                   
                    <div className="my-auto">
                     <div className="text-center mb-5">
                      <img src={rexo_logo} alt="" height="40" className="" />
                      </div>
                      <div>
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p className="text-muted">  Log in to continue to Rexo Pathology. </p>
                      </div>

                      <SuperAdminLogin />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <ToastContainer />

      </>
    );
  }
}

// const mapStateToProps = (state) => ({
//   // superAdminLoginRes:  state.superAdminLoginRes, // Adjust according to your reducer
// });

// Login2.propTypes = {
//   error: PropTypes.any,
// };

// export default Login2;
export default Login2;
